/*
  教师信息管理
*/
import request from "@/utils/request";
let baseUrl1 = window.config.baseUrl1  // 梁江辉接口地址1
let baseUrl2 = window.config.baseUrl2  // 飞泉接口地址online

//获取教师信息管理页面参数
export function getParam() {
  return request({
    url: "/baseinfo/teacherinfo/getParam",
    method: "get"
  });
}

//获取教师信息管理页面参数
export function getTeacherInfoByCardId(cardId) {
  return request({
    url: "/baseinfo/projectMaterial/getTeacherInfoByCard?teacherCard=" + cardId,
    method: "get"
  });
}

//获取教师信息管理分页列表
export function getTeacherInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/getTeacherInfo",
    method: "get",
    params
  });
}

//保存或编辑教师信息
export function saveOrUpdate(data) {
  return request({
    url: "/baseinfo/teacherinfo/editBaseInfo",
    method: "post",
    data
  });
}

//编辑教师报名信息
export function saveOrUpdateEnrollInfo(data) {
  return request({
    url: "/baseinfo/teacherinfo/editSignInfo",
    method: "post",
    data
  });
}

//添加教师信息
export function addTeacherInfo(data) {
  return request({
    url: "/baseinfo/teacherinfo/add",
    method: "post",
    data
  });
}

//删除教师信息
export function deleteTeacherInfo(data) {
  return request({
    url: "/baseinfo/teacherinfo/deleteTeacherInfo",
    method: "post",
    data
  });
}

//标记是否有效
export function markValid(data) {
  return request({
    url: "/baseinfo/teacherinfo/markValid",
    method: "post",
    data
  });
}

//推荐或取消推荐
export function setRecommend(data) {
  return request({
    url: "/baseinfo/teacherinfo/setRecommend",
    method: "post",
    data
  });
}

//发送短信息
export function sendMessageTeacherInfoManage(data) {
  return request({
    url: "/baseinfo/teacherinfo/sendMessage",
    method: "post",
    data
  });
}

//发送通知
export function sendNoticeTeacherInfoManage(data) {
  return request({
    url: "/baseinfo/teacherinfo/sendInform",
    method: "post",
    data
  });
}

//教师总人数/有效人数
export function validTeacherNum(projectId) {
  let url = "/baseinfo/teacherinfo/validTeacherNum";
  if(projectId){
    url += `?projectId=${projectId}`
  }
  return request({
    url,
    method: "get"
  });
}

//查看教师详情信息
export function getTeacherDetailInfo(params) {
  return request({
    url: "/baseinfo/teacherinfo/getTeacherDetailInfo",
    method: "get",
    params
  });
}

// 获取短信教师名单
export function getMsgTeacher(params: Object) {
  return request({
    url: "/baseinfo/teacherinfo/getMsgTeacher",
    method: "get",
    params
  });
}


//推荐或取消推荐
export function auditTeacher(data) {
  return request({
    url: "/baseinfo/teacherinfo/auditTeacher",
    method: "post",
    data
  });
}

// 下载教师身份证照片（ZIP打包）
export function downloadPhotos(data: any) {
  return request({
    url: "/baseinfo/teacherinfo/downloadPhotos",
    method: "post",
    data,
    responseType: "blob"
  });
}

// 检查教师信息是否可编辑
export function checkCanEdit(teacherId: string, projectId: string) {
  return request({
    url: "/baseinfo/maintain/checkCanEdit",
    method: "get",
    params: { teacherId, projectId }
  });
}
